import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import styles from './TraderDashboard.module.css';

const LoadingView = ({ message = 'Loading session...' }) => (
  <div className={styles.dashboardContainer}>
    <div className={styles.loadingState}>
      <FontAwesomeIcon icon={faSpinner} spin /> {message}
    </div>
  </div>
);

LoadingView.propTypes = {
  message: PropTypes.string,
};

export default LoadingView;